import React from 'react'
import { Controller } from 'react-hook-form'
import { Input } from 'app/components/atoms'
import { useTranslation } from 'app/i18n/client'
import { Control } from 'react-hook-form'
import { InputProps } from 'app/components/atoms/Input'

interface FormInputProps extends InputProps {
  control?: Control<any>
  name: string
  containerId?: string
  defaultValue?: string
  error?: any
  controllerProps?: any
}

const FormInput = ({
  controllerProps,
  control,
  cardInputType,
  name,
  containerId,
  defaultValue,
  error,
  ...rest
}: FormInputProps) => {
  const { t } = useTranslation()

  return (
    <Controller
      control={control}
      render={({ field: { onChange, onBlur, value } }) => (
        <Input
          {...rest}
          containerId={containerId}
          name={name}
          // Coerce to '' so the underlying <input> is always controlled.
          // RHF returns undefined for fields without defaultValues; once the
          // form populates them (e.g. from the profile query), value flips to
          // a string and React logs an "uncontrolled → controlled" warning.
          value={value ?? ''}
          cardInputType={cardInputType}
          onBlur={rest?.onBlur || onBlur}
          onChangeText={onChange}
          isError={rest?.isError || !!error}
          errorMessage={rest?.errorMessage || t(error?.message)}
        />
      )}
      name={name}
      defaultValue={defaultValue}
      {...controllerProps}
    />
  )
}

export default FormInput
